module.exports = __webpack_public_path__ + "static/media/oasis-appsuite-quickbase-plugins.57a632e4.png";